// extracted by mini-css-extract-plugin
module.exports = {"container":"ArticlesByTag_container____t0z"};